
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autorzy/krystyna-gasiorek",
      function () {
        return require("private-next-pages/autorzy/krystyna-gasiorek/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autorzy/krystyna-gasiorek"])
      });
    }
  